import {
  getCollectionStartTimeInitialValue,
  serializeCollectionStartTime,
} from './collection-time';

const MODIFIED_TIME_FIELD_TYPE = 1002;

const STORE_FIELD_MAPPINGS = [
  { key: 'codeFieldId', label: '门店编码', required: true },
  { key: 'nameFieldId', label: '门店名称', required: true },
  { key: 'businessStatusFieldId', label: '营业状态' },
  { key: 'businessFormatFieldId', label: '业态' },
  { key: 'inventoryManagerNameFieldId', label: '库管' },
  { key: 'openedAtFieldId', label: '开业日期' },
  { key: 'areaFieldId', label: '面积' },
  { key: 'regionFieldId', label: '地域', required: true },
  { key: 'businessAddressFieldId', label: '营业地址' },
];

const requireMetadataItem = (items, key, value, message) => {
  const item = items.find((candidate) => candidate[key] === value);
  if (!item) {
    throw new Error(message);
  }
  return item;
};

const getFeishuStoreCollectionInitialValues = (record) => {
  if (!record) {
    return { fieldMapping: {} };
  }
  return {
    ...record,
    sourceConfig: {
      ...record.sourceConfig,
      startTime: getCollectionStartTimeInitialValue(record.sourceConfig.startTime),
    },
    sourceReference: record.sourceConfig.sourceUrl || '',
  };
};

const getFeishuStoreCollectionResetValues = (sourceConfig) => ({
  sourceConfig: { ...sourceConfig, cursorFieldId: undefined },
  fieldMapping: Object.fromEntries(STORE_FIELD_MAPPINGS.map(({ key }) => [key, undefined])),
});

const buildFeishuStoreCollectionValues = (values, metadata) => {
  const { sourceConfig, fieldMapping } = values;
  requireMetadataItem(
    metadata.tables,
    'tableId',
    sourceConfig.tableId,
    '数据表已不存在，请重新选择',
  );
  requireMetadataItem(metadata.views, 'viewId', sourceConfig.viewId, '视图已不存在，请重新选择');
  const cursorField = requireMetadataItem(
    metadata.fields,
    'fieldId',
    sourceConfig.cursorFieldId,
    '最后更新时间字段已不存在，请重新选择',
  );
  if (cursorField.type !== MODIFIED_TIME_FIELD_TYPE) {
    throw new Error('最后更新时间字段必须是 ModifiedTime 类型，请重新选择');
  }
  const normalizedFieldMapping = {};
  for (const { key, label, required } of STORE_FIELD_MAPPINGS) {
    const fieldId = fieldMapping[key];
    if (!fieldId) {
      if (required) {
        throw new Error(`请选择${label}字段`);
      }
      continue;
    }
    requireMetadataItem(metadata.fields, 'fieldId', fieldId, `${label}字段已不存在，请重新选择`);
    normalizedFieldMapping[key] = fieldId;
  }
  const fieldIds = Object.values(normalizedFieldMapping);
  if (new Set(fieldIds).size !== fieldIds.length) {
    throw new Error('同一字段不能用于多个门店主数据属性');
  }
  return {
    connectionId: values.connectionId,
    name: values.name,
    sourceConfig: {
      sourceUrl: values.sourceReference.trim(),
      appToken: sourceConfig.appToken,
      cursorFieldId: sourceConfig.cursorFieldId,
      tableId: sourceConfig.tableId,
      viewId: sourceConfig.viewId,
      startTime: serializeCollectionStartTime(sourceConfig.startTime),
    },
    fieldMapping: normalizedFieldMapping,
  };
};

export {
  buildFeishuStoreCollectionValues,
  getFeishuStoreCollectionInitialValues,
  getFeishuStoreCollectionResetValues,
  STORE_FIELD_MAPPINGS,
};
